<mat-card class="flex flex-row gap-2">
  <mat-card-content class="!p-0">
    <mat-spinner class="!w-16 !h-16"></mat-spinner>
  </mat-card-content>

  <mat-card-footer>
    {{ data.message }}
  </mat-card-footer>
</mat-card>
